import { FormInputProps } from "./FormInput.types"
import "./FormInput.css"

const FormInput = (props: FormInputProps) => {

  const { label, input, className, disabled } = props

  return (
    <div className={`form-input-container ${className ?? ""}`}>
      <p className="form-input-label">{label}</p>
      <input
        type="text"
        disabled={disabled}
        className="form-input"
        value={input.value}
        onChange={(e) => input.onChange(e.target.value)}
        placeholder={input.placeholder}
      />
      {input.error !== null && (
        <p className="form-input-error-label">{input.error?.message}</p>
      )}
    </div>
  )
}

FormInput.defaultProps = {
  disabled: false
}

export default FormInput